import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MenuService {

    private menuSource = new Subject<string>();
    private resetSource = new Subject();
    private itemsSource = new Subject<any[]>();
    private nameSource = new Subject<string>();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();
    itemsHandler = this.itemsSource.asObservable();
    nameHandler = this.nameSource.asObservable();

    onMenuStateChange(key: string) {
        this.menuSource.next(key);
    }

    reset() {
        this.resetSource.next();
    }

    setItems(items: any[]) {
        this.itemsSource.next(items);
    }

    setName(name: string) {
        this.nameSource.next(name);
    }
}
